import React, { useEffect, useState, useContext, useRef } from 'react'
import Layout from '../components/Layout';
import Chatter from '../components/Chatter';
import { useParams } from "react-router-dom";
import { Chip, Grid, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import MediaGrid from '../components/MediaGrid';
import axios from 'axios';
import { GlobalContext } from '../contexts/GlobalContext';
import { format, parse } from 'date-fns'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Collapse from '@mui/material/Collapse';

import IconButton from '@mui/material/IconButton';
import { IconChevronDown, IconChevronUp } from '@tabler/icons-react';
import { red, amber, green } from '@mui/material/colors';

function Order() {
    let { id } = useParams();

    const { url,  token, cdn } = useContext(GlobalContext);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});

    useEffect(() => {
        fetchData();
        if(window.cordova) {
            window.cordova.plugins.firebase.analytics.setCurrentScreen("Order View");
        }
    }, [ ]);

    const fetchData = async () => {
        await axios.post( url + `api/admin/voucher/${id}`, {}, { 
            headers: { Authorization: `Bearer ${token}` }
        })
        .then(function (response) {
            setData(response.data);
            setLoading(false);
        })
        .catch(function (error) {
            console.log(error);
        });
    }

    const FloatDetails = () => {

        return (
            <Paper sx={{ border: 1, borderBottom: 1,  borderColor: 'divider', textAlign: 'center', m:2 }}>
                <Box sx={{display: "flex"}}>
                <Box sx={{ borderBottom: 1, borderRight: 1, borderColor: 'divider', px: 2, py:1, flex:1}}>
                    <Typography variant="overline" component="p">Buyer</Typography>
                    <Typography variant="body" component="p">{data.voucher?.buyer_name}{!!data?.voucher?.buyer_city && <span style={{ fontWeight: 400, fontSize: "0.9em", color: "gray"}}>, {data.voucher.buyer_city}</span>}</Typography>
                    {!!data?.voucher?.buyer_msme &&  <Box><Chip variant="outlined" color="primary" size="small" label={data?.voucher?.buyer_msme} /></Box>}
                </Box>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2, py:1, flex:1}}>
                    <Typography variant="overline" component="p">Supplier</Typography>
                    <Typography variant="body" component="p">{data.voucher?.seller_name}{!!data?.voucher?.seller_city && <span style={{ fontWeight: 400, fontSize: "0.9em", color: "gray"}}>, {data.voucher.seller_city}</span>}</Typography>
                    {!!data?.voucher?.seller_msme &&  <Box><Chip variant="outlined" color="primary" size="small" label={data?.voucher?.seller_msme} /></Box>}
                </Box>
                </Box>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 1, py:1 }}>
                        <Typography variant="overline" component="p">Date</Typography>
                        <Typography variant="body" component="p">{ data.voucher.date ? format(parse(data.voucher.date, 'yyyy-MM-dd', new Date()), 'dd MMM yyyy') : "-" }</Typography>
                </Box>
                <Box sx={{ borderColor: 'divider', px: 1, py:1 }}>
                    <Typography variant="overline" component="p">Remarks</Typography>
                    <Typography variant="body" component="p">{data.voucher.remarks ? data.voucher.remarks : '-'}</Typography>
                </Box>
                <Box sx={{ borderTop: 1, borderColor: 'divider', width: '100%' }}>
                    <MediaGrid dir="orders" images={data.voucher.images} />
                </Box>
            </Paper>
        )
    }

    const Items = () => {
        console.log("data", data);
        

        return (
            <Box>
                <>
                    <TableContainer component={Paper} sx={{ my: 2 }}>
                        <Table stickyHeader aria-label="collapsible table">
                            <TableHead>
                            <TableRow>
                                <TableCell width="30px" />
                                <TableCell width="50px" align="left" size="small">No.</TableCell>
                                <TableCell align="left">Particular</TableCell>
                                { !data?.voucher?.entry_id ? 
                                    <TableCell align="left">Size</TableCell>
                                    : 
                                    <TableCell align="left">Category</TableCell> 
                                }
                                <TableCell align="right">Rate</TableCell>
                                <TableCell align="right">Qty</TableCell>
                                <TableCell align="right">Invoiced</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {!!data?.voucher?.clients_voucher_items && data?.voucher?.clients_voucher_items?.length > 0 &&
                                data?.voucher?.clients_voucher_items?.map((row, index) => (
                                    <ItemRow key={row.sno} row={row} index={index+1} />
                                ))
                            }

                            { !data?.voucher?.entry_id && data?.voucher?.items &&

                                JSON.parse(data?.voucher?.items)?.map((item, index) => {
                                    return <OrderFormItems key={index+1} item={item} index={index} />
                                } )
                            }

                            {(data?.summary?.totalQty || data?.summary?.total) &&

                                <TableRow>
                                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                                        <Box sx={{width: "100%", padding: "10px", display: "flex", flexDirection: "row"}}>
                                            {data?.summary?.totalQty != null &&
                                            <Box sx={{ flex: 1}}>
                                                <Typography variant="body2" sx={{textAlign: "center"}}>Total Qty: {data?.summary?.totalQty}</Typography>
                                            </Box>}
                                            {data?.summary?.total != null &&
                                            <Box sx={{ flex: 1}}>
                                                <Typography variant="body2" sx={{textAlign: "center"}}>Total Amount: &#8377;{data?.summary?.total}</Typography>
                                            </Box>}                                    
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Box sx={{ display: 'flex', justifyContent:"center", alignItems:"center", flexDirection: 'row', gap: 1, mb: 2 }}>
                        <Chip label="Pending" sx={{color: "#000", backgroundColor: red[100]}} />
                        <Chip label="Invoiced" sx={{color: "#000", backgroundColor: green[100]}} />
                        <Chip label="Excess Invoiced" sx={{color: "#000", backgroundColor: amber[100]}} />
                    </Box>
                </>            
            </Box>
        )
    }

    const ItemRow = (props) => {
        const rowBackgroundColors = {
            "excess": amber[100], // just for example, remove it if you don't need
            "match": green[100],
            "less": red[100],
          };

        const { row, index } = props;
        const [open, setOpen] = React.useState(false);

        if(!row.hasOwnProperty('invoiced')){
            row.invoiced = 0;
        }
        var bgClass = "less";
        if(parseFloat(row.invoiced) == parseFloat(row.qty)) {
            bgClass = "match";
        } else if(parseFloat(row.invoiced) > parseFloat(row.qty)) {
            bgClass = "excess";
        }

        if(row.image == null) {
            var images = [];
        } else {
            var images = JSON.parse(row.image);
        }

        return (
          <>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: rowBackgroundColors[bgClass] }}>
              <TableCell>
                <IconButton sx={{color:"#000"}} aria-label="expand row" size="small" onClick={() => setOpen(!open)}>{open ? <IconChevronUp /> : <IconChevronDown />}</IconButton>
              </TableCell>
              <TableCell align="left" sx={{color:"#000"}}>{index}</TableCell>
              <TableCell align="left" sx={{color:"#000"}}>{row.particular}</TableCell>
              <TableCell align="left" sx={{color:"#000"}}>{row.category_details?.name || ""}</TableCell>
              <TableCell align="right" sx={{color:"#000"}}>{row.rate}</TableCell>
              <TableCell align="right" sx={{color:"#000"}}>{row.qty}</TableCell>
              <TableCell align="right" sx={{color:"#000"}}>{row.invoiced}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <Box sx={{ margin: 1 }}>
                    <Typography variant="h6" gutterBottom component="div">Details</Typography>
                    <Grid container>
                        {
                            JSON.parse(row.attributes).length > 0 &&
                            JSON.parse(row.attributes).map( attribute => {
                                return (
                                    <>
                                        <Grid item xs={6} md={3} sx={{ px: 1, py:1 }}>
                                            <Typography variant="overline" component="p">{attribute.name}</Typography>
                                            <Typography variant="body" component="p">{attribute.value}</Typography>
                                        </Grid>
                                    </>
                                )
                            })
                        }
                        <Grid item xs={6} md={3} sx={{ px: 1, py:1 }}>
                            <Typography variant="overline" component="p">Discount (%)</Typography>
                            <Typography variant="body" component="p">{row.discount}</Typography>
                        </Grid>
                        <Grid item xs={6} md={3} sx={{ px: 1, py:1 }}>
                            <Typography variant="overline" component="p">Total Discount (&#8377;)</Typography>
                            <Typography variant="body" component="p">&#8377;{row.total_discount_amount}</Typography>
                        </Grid>
                        <Grid item xs={6} md={3} sx={{ px: 1, py:1 }}>
                            <Typography variant="overline" component="p">Tax (%)</Typography>
                            <Typography variant="body" component="p">{row.tax}</Typography>
                        </Grid>
                        <Grid item xs={6} md={3} sx={{ px: 1, py:1 }}>
                            <Typography variant="overline" component="p">Total</Typography>
                            <Typography variant="body" component="p">&#8377;{row.subtotal}</Typography>
                        </Grid>
                        {
                            Object.keys(images).length ?
                            <Grid item xs={6} md={3} sx={{ px: 1, py:1 }}>
                                <img style={{ width: 140+"px", height: "auto", borderRadius: "4px" }} src={cdn + 'catalog/' + images[0].file} data-fancybox="products" href={cdn + 'catalog/' + images[0].file}/>
                            </Grid>
                            :
                            <></>
                        }
                    </Grid>
                    
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </>
        );
    }



    const OrderFormItems = ({item, index}) => {

        const [open, setOpen] = useState(false);

        const rowBackgroundColors = {
            excess: amber[100],
            match: green[100],
            less: red[100],
          };
          
        
        item.invoiced = item.invoiced ?? 0;
        
        const bgClass = 
            parseFloat(item?.invoiced) === parseFloat(item?.qty) ? "match" :
            parseFloat(item?.invoiced) > parseFloat(item?.qty) ? "excess" :
            "less";
        
        const images = (item?.image && item.image != null ) ? JSON.parse(item.image) : [];
        
        useEffect(() => {console.log({item})}, [item]);
        if (Boolean(item) === false) return <></>

        return (
          <>
            <TableRow sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: rowBackgroundColors[bgClass] }}>
              <TableCell>
                <IconButton sx={{color:"#000"}} aria-label="expand row" size="small" onClick={() => setOpen(!open)}>{open ? <IconChevronUp /> : <IconChevronDown />}</IconButton>
              </TableCell>
              <TableCell align="left" sx={{color:"#000"}}>{index+1}</TableCell>
              <TableCell align="left" sx={{color:"#000"}}>{item?.particular}</TableCell>
              <TableCell align="left" sx={{color:"#000"}}>{item?.attributes[0]?.value || ""}</TableCell>
              <TableCell align="right" sx={{color:"#000"}}>{"\u20B9"} {item?.rate}</TableCell>
              <TableCell align="right" sx={{color:"#000"}}>{item?.qty}</TableCell>
              <TableCell align="right" sx={{color:"#000"}}>{item?.invoiced}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                <Collapse in={open} timeout="auto" unmountOnExit>
                  <Box sx={{ margin: 1 }}>
                    <Typography variant="h6" gutterBottom component="div">Details</Typography>
                    <Grid container>
                        <Grid item xs={6} md={3} sx={{ px: 1, py:1 }}>
                            <Typography variant="overline" component="p">Discount (%)</Typography>
                            <Typography variant="body" component="p">{item?.discount}</Typography>
                        </Grid>
                        <Grid item xs={6} md={3} sx={{ px: 1, py:1 }}>
                            <Typography variant="overline" component="p">Total Discount (&#8377;)</Typography>
                            <Typography variant="body" component="p">&#8377;{item?.totalDiscountAmount}</Typography>
                        </Grid>
                        <Grid item xs={6} md={3} sx={{ px: 1, py:1 }}>
                            <Typography variant="overline" component="p">Tax (%)</Typography>
                            <Typography variant="body" component="p">{item?.tax}</Typography>
                        </Grid>
                        <Grid item xs={6} md={3} sx={{ px: 1, py:1 }}>
                            <Typography variant="overline" component="p">Total</Typography>
                            <Typography variant="body" component="p">&#8377;{item?.subTotal}</Typography>
                        </Grid>
                        
                        {/* {
                            Object.keys(images).length ?
                            <Grid item xs={12} md={3} sx={{ px: 1, py:1 }}>
                                <img style={{ width: 140+"px", height: "auto", borderRadius: "4px" }} src={cdn + 'catalog/' + images[0]?.file} data-fancybox="products" href={cdn + 'catalog/' + images[0].file}/>
                            </Grid>
                            :
                            <></>
                        } */}
                    </Grid>
                    
                  </Box>
                </Collapse>
              </TableCell>
            </TableRow>
          </>
        );

    }
    return (
        <div>
            <Layout title="Chat" nopadding={true}>
                {data.voucher?.order_type === 4 &&
                    data.voucher?.chat_channel !== null &&
                    data.voucher?.voucher_type === "orders" ? (
                    <Chatter
                        id={data.voucher.chat_channel}
                        FloatDetails={FloatDetails}
                    />
                ) : data.voucher?.order_type === null &&
                    data.voucher?.chat_channel === null ? (
                    <>
                        <FloatDetails />
                        <Items />

                    </>
                ) : null}
            </Layout>
        </div>
    );
}

export default Order;
